<div *ngFor="let stats of statsAndCount;" class="ui-g-3 ui-md-3 ui-lg-3">
  <div class="platform-summery-container">
    <div class="summery-count">{{stats.count === null ? 0: stats.count}}</div>
    <div class="summery-title">{{stats.label}}</div>
  </div>
</div>